import { parsePhoneNumberFromString } from "libphonenumber-js"
import type { Lead } from "@/shared/api/generated/types/marketing"

export const formatLeadPhone = (phone: string, normalized: string) => {
	const normalizedDigits = normalized.replace(/\D/g, "")
	const candidates = [phone, normalizedDigits ? `+${normalizedDigits}` : ""]

	for (const candidate of candidates) {
		if (!candidate) continue
		const parsed = parsePhoneNumberFromString(candidate)
		if (parsed?.isValid()) return parsed.formatInternational()
	}

	return phone
}

export const formatLeadDate = (value: string, locale: string) =>
	new Intl.DateTimeFormat(locale, {
		dateStyle: "short",
		timeStyle: "short",
	}).format(new Date(value))

export const formatLeadUtmShort = (lead: Lead) =>
	[lead.utm.source, lead.utm.medium, lead.utm.campaign]
		.filter(Boolean)
		.join(" / ") || "—"

export const formatLeadSource = (source: string | undefined) => source || "—"
